import { createFileRoute } from '@tanstack/react-router'
import * as React from 'react'
import { CaseListScreen, type CaseListSearch, parseCaseListSearch } from '../features/queue/case-list-screen'

export const Route = createFileRoute('/cases/open')({
  validateSearch: (raw: Record<string, unknown>): CaseListSearch => parseCaseListSearch(raw),
  component: function CasesOpenRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const onSearch = React.useCallback((next: CaseListSearch) => void navigate({ search: next, replace: true }), [navigate])
    return <CaseListScreen scope="open" search={search} onSearch={onSearch} />
  },
})
